module.exports = __webpack_public_path__ + "img/5_28.1cc4d5ff.png";